import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useProspect(prospectId) {
  const [prospect, setProspect] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.affiliates.prospects.show(prospectId))
      .then((response) => {
        setProspect(response.data.data);
      });
  }, []);

  return prospect;
}
